import React from 'react'
import styles from './CategorySelector.module.css'

const CategoryItem = ({ label, isSelected, onClick }) => {
    return (
        <div
            className={`${styles.categoryItem} ${isSelected ? styles.selected : ''} ${isSelected ? 'bg-primary' : ''}`}
            onClick={onClick}
            data-category-item={label}
        >
            {label}
        </div>
    )
}

export default CategoryItem
